import { createContext } from "react";

export const LoadingContext = createContext({
  loading: false,
  setLoading: () => {
    throw new Error("Wrap your app in LoadingProvider");
  }
});
